import React from 'react'
import {
  Box, Typography, Accordion, AccordionSummary, AccordionDetails, Paper, Stack,
} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ResourceList from './ResourceList'

// Renders one model: its name, description and version accordions (latest
// version first and expanded). Shared by the full product page and the
// scoped /view pages.
export default function ModelSection({ model }) {
  // The API returns versions oldest-first; show them newest-first here.
  const versions = [...model.versions].reverse()

  return (
    <Box sx={{ mb: 4 }}>
      <Typography variant="h5" gutterBottom>{model.name}</Typography>
      {model.description && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          {model.description}
        </Typography>
      )}

      {versions.length === 0 ? (
        <Typography color="text.secondary">Версій ще немає.</Typography>
      ) : (
        versions.map((version, index) => (
          <Accordion
            key={version.id}
            component={Paper}
            disableGutters
            /* Expand the latest version — now first in the list — by default. */
            defaultExpanded={index === 0}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Stack spacing={0.25} sx={{ pr: 1 }}>
                <Typography sx={{ fontWeight: 600 }}>{version.name}</Typography>
                {version.description && (
                  <Typography variant="body2" color="text.secondary">
                    {version.description}
                  </Typography>
                )}
              </Stack>
            </AccordionSummary>
            <AccordionDetails>
              <ResourceList resources={version.resources} />
            </AccordionDetails>
          </Accordion>
        ))
      )}
    </Box>
  )
}
